import React from 'react';
import { withTranslation } from "react-i18next";
import CaAccountModalView from "./CaAccountModalView";

const CaAccountChangeEmailContainer = props => {

    const newProps = Object.assign({},{
        formFieldsData: [
            {type:'email',    validateAs:'email', placeholder:props.t('account_modal.placeholders.new_email'),   id:"change_email"},
            {type:'password', validateAs:'password', placeholder:props.t('account_modal.placeholders.password'), id:"change_password"}
        ],
        "title": props.t('account_modal.change_email.title'),
        "body": props.t('account_modal.change_email.body'),
        "success_message": props.t('account_modal.change_email.success_message'),
        "submitCta": props.t('account_modal.change_email.submitCta')
    });

    return (
        <CaAccountModalView
            {...Object.assign({},props,newProps)}
        />
    )
}
export default withTranslation("translations")(CaAccountChangeEmailContainer);